/**
 * AUTO-GENERATED by scripts/build-resume.mjs from resume.json.
 * Do not edit by hand -- changes will be overwritten on next build.
 * Edit resume.json and run `pnpm resume:build`.
 */

import { Experience, Education } from '@/types'

/** YYYY-MM stamp from resume.json. Surfaced on the Resume page. */
export const resumeLastUpdated = '2026-08'

export const experience: Experience[] = [
  {
    id: 'nike-0',
    company: 'Nike',
    position: 'Lead Data Scientist',
    location: 'Remote',
    startDate: '2023-07-01',
    current: true,
    description: [
      'Led technical deployment of a production 900K-variable weekly Mixed Integer Program (MIP) containerization model (gurobipy, Databricks) codifying 21 loading rules with rejection-driven feedback; scaled from pilot to 5 origin ports serving 17.5% of global inbound volume, lifting consolidator-bypass from 11% baseline to 45%+ and saving $2.8M annually.',
      'Led ablation experimentation across 22 EMEA loading rules to isolate consolidator-bypass degradation on containerization rollout; identified ETA-zoning rules as dominant uplift lever (5-7pp), driving $236K in cost savings via post-launch parameter retuning.',
      'Owned end-to-end a 413K-variable inventory allocation MIP (supply-demand matching, gurobipy on Databricks Apps), from stakeholder scoping through React/FastAPI front-end, clearing Nike marketplace demand across 23 DCs; delivered 157K-unit cross-territory divert ($2.5M) with $10M+ annualized avoided-cancellation savings for 27 analysts.',
      'Owned a 3-person consulting squad end-to-end; mentored 8 data scientists, conducted 20+ hiring interviews, and led 30+ onboarding sessions.',
      'Presented 10+ times at the enterprise Data Science Demo Series, sharing machine learning, experimentation, and supply chain optimization work with cross-functional audiences of data scientists, engineers, and business stakeholders.',
    ],
    technologies: ['Python', 'Gurobi', 'gurobipy', 'OR-Tools', 'PyTorch', 'CatBoost', 'Databricks', 'Databricks Apps', 'AWS SageMaker', 'AWS ECR', 'Snowflake', 'Delta Tables', 'medallion architecture', 'TypeScript', 'React', 'FastAPI', 'Docker', 'Jenkins', 'CI/CD', 'PyTest', 'Airflow', 'Streamlit'],
    type: 'full-time',
  },
  {
    id: 'nike-1',
    company: 'Nike',
    position: 'Senior Data Scientist',
    location: 'Remote',
    startDate: '2022-01-01',
    endDate: '2023-07-01',
    current: false,
    description: [
      'Architected a supply chain network Digital Twin (60K-variable MIP in Gurobi/OR-Tools) replacing Supply Chain Guru X, optimizing cost, lead time, risk, and emissions across 1.6B units via Pareto frontier, sensitivity, and scenario analysis; delivered $202M EBIT, $1M annual license savings, and 100M kg CO2e reduction in year one; shipped on AWS SageMaker via Jenkins CI/CD.',
      'Trained CatBoost models on 180K Snowflake records for landed-cost pricing (FOB + duty) at SKU-factory granularity: 4.05% MAPE on FOB (56% below static weighted-average baseline), 19% error reduction on duty; monthly Airflow retrain, integrated into sourcing optimizers, served via Streamlit to 150+ designers.',
      'Built 12 medallion-architecture ETL pipelines (Python, SQL) on AWS SageMaker and Databricks across 5 products, automating ingestion from Snowflake, Box, and Delta Tables; containerized in Docker and hardened with PyTest unit tests.',
    ],
    technologies: ['Python', 'Gurobi', 'gurobipy', 'OR-Tools', 'PyTorch', 'CatBoost', 'Databricks', 'Databricks Apps', 'AWS SageMaker', 'AWS ECR', 'Snowflake', 'Delta Tables', 'medallion architecture', 'TypeScript', 'React', 'FastAPI', 'Docker', 'Jenkins', 'CI/CD', 'PyTest', 'Airflow', 'Streamlit'],
    type: 'full-time',
  },
  {
    id: 'ibm',
    company: 'IBM',
    position: 'Senior Data Scientist',
    location: 'Washington, DC',
    startDate: '2020-04-01',
    endDate: '2021-12-01',
    current: false,
    description: [
      'Built 2-stage MILP (Python/PuLP) combining multi-commodity network flow and bin-packing (materiel compatibility) for DLA munitions sourcing/distribution on Palantir Foundry with PySpark; cut planning from 1 week to 8 minutes across ~4K SKUs.',
      'Engineered LSTM encoder-decoder (TensorFlow) forecasting 12-month backorders across 33K SKUs, using tslearn for segmentation and cluster-guided oversampling; benchmarked 6 architectures via walk-forward CV (0.89 F1, 0.94 recall); published DLA technical report.',
      'Developed MLP/RNN classifiers (scikit-learn, TensorFlow) labeling Primary Failure Indicators from maintenance logs across 30+ failure modes at 85% accuracy; cut reliability curve development from 6 months to 4 weeks; adopted by the Air Force across 5 engine programs.',
      'Developed bidirectional LSTM classifiers (TensorFlow, GloVe embeddings) fusing free-text and structured fields to classify security clearance applications at 0.91 recall and 0.89 F1 with SMOTE; SHAP force plots drove Army adoption.',
    ],
    technologies: ['Python', 'PySpark', 'PuLP', 'TensorFlow', 'Palantir Foundry', 'scikit-learn', 'GloVe', 'Pandas', 'SQL', 'SMOTE', 'SHAP', 'LIME', 'tslearn'],
    type: 'full-time',
  },
  {
    id: 'accenture-0',
    company: 'Accenture',
    position: 'Senior Technical Supply Chain Analyst',
    location: 'Arlington, VA',
    startDate: '2017-02-01',
    endDate: '2018-08-01',
    current: false,
    description: [
      'Enhanced DLA aviation SKU recommendations by building a hybrid retrieval pipeline (SAS, SQL) combining rule-based clustering (vendor, socioeconomic sourcing) with product keyword cosine similarity to extend candidate SKU sets; outputs pushed to a dashboard used by 300+ analysts, informing $1.2B+ contracting decisions.',
      'Led development of a supply chain network dashboard in Qlik Sense for DLA distribution center performance monitoring; engineered supporting Python (Pandas, NumPy) and PostgreSQL data pipelines.',
    ],
    technologies: ['SAS', 'SQL', 'Python', 'Pandas', 'NumPy', 'PostgreSQL', 'SAP HANA', 'Qlik Sense'],
    type: 'full-time',
  },
  {
    id: 'accenture-1',
    company: 'Accenture',
    position: 'Program and Project Management Analyst',
    location: 'Arlington, VA',
    startDate: '2016-03-01',
    endDate: '2017-02-01',
    current: false,
    description: [
      'Supported HealthCare.gov modernization at CMS: monitored SDLC phase milestones, compiled weekly risk reports, tracked contract financials, and maintained vendor resource compliance across dev, QA, and infrastructure workstreams.',
    ],
    technologies: ['SAS', 'SQL', 'Python', 'Pandas', 'NumPy', 'PostgreSQL', 'SAP HANA', 'Qlik Sense'],
    type: 'full-time',
  },
]

export const education: Education[] = [
  {
    id: 'gwu',
    institution: 'George Washington University',
    degree: 'Master of Science',
    field: 'Computer Science',
    startDate: '2018-08-01',
    endDate: '2019-12-01',
  },
  {
    id: 'lafayette',
    institution: 'Lafayette College',
    degree: 'Bachelor of Science',
    field: 'Mechanical Engineering',
    startDate: '2011-08-01',
    endDate: '2015-05-01',
  },
]
